<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="false">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放
        </el-col>
        <div class="quImg" v-if="heart.questionDto.detailInfo.questionWriteUrl">
            <img :src="heart.questionDto.detailInfo.questionWriteUrl" alt="" srcset="">
        </div>
        <el-col :span="24" class="imgStyle" align="left" :style="{top:(heart.questionDto.detailInfo.questionWriteUrl? '40%':'45px'),paddingTop:(heart.questionDto.detailInfo.questionWriteUrl? '18px':'51px')}">
            <div class="playTheDrumsLeft" v-if="!updataImgUrl"></div>
            <div class="haveGotOnTheBus" v-else>
                <img :src="updataImgUrl" alt="图片">
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import updataImg from '../../components/updataImg'
import utils from '../../lib/util'
    export default {
        name:"listenWrite",
        props: {
            sonData: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:[],
                plays:0,
                questionImgUrl:'',
                updataImgUrl:'',
                yangText:'上传图片',
            }
        },
        components:{
            audioStyle,
            updataImg
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.updataImgUrl = this.heart.errorObj.writeImgUrl
                this.plays = utils.mottoClone(this.heart.questionDto.detailInfo.playTime)

            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(1000)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            upImgUrl(url){
                this.updataImgUrl = url
                this.$refs.upImg.url = '',
                this.$refs.upImg.fileList = [],
                this.yangText = ' 重  拍 '
            },
            yesNotProblem(){
                this.questionImgUrl = this.updataImgUrl
                if(this.updataImgUrl) return true
                return false
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .quImg{
            position: absolute;
            top: 0;
            left: 0;
            box-sizing: border-box;
            padding-top: 55px;
            width: 100%;
            height: 40%;
            display: inline-block;
            pointer-events: none;
            img{
                display: table-cell;
                vertical-align: middle;
                align-items: center;
                max-height: 100%;
                max-width: 70%;
            }
        }
        .imgStyle{
            position: absolute;
            top: 40%;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .playTheDrumsLeft{
                width: 38%;
                height: 100%;
                float: left;
                position: relative;
                background-repeat: no-repeat;
            }
            .haveGotOnTheBus{
                width: 86%;
                height: 90%;
                margin-top: 2.5%;
                float: left;
                margin-left: 7%;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/examRecords/listenWrite.vue